.callToAction {
  margin: 48px 0 0 0;
  display: flex;
  flex-direction: column;
}

.promotionCard {
  margin: -20px 0 -1px 0;
  display: flex;
  flex-direction: column;
}

@media (min-width: 900px) {
  .promotionCard {
    display: none;
  }
}
